import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const CertificateTable = ({ data, size }) => {
    const { t } = useTranslation('translation', { keyPrefix: "traineeships.singleView.traineeshipCertificate"})

    // Function to format date from YYYY-MM-DD to DD-MM-YYYY
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString; // Return original if invalid
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    if (!data) {
        return (
            <Container>
                <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                    <Col>
                        <Row style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <Col className='text-center'>{t('noCertAvailable')}</Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container>
            <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                <Col>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('titleOfPositionRole')}:
                        </Col>
                        <Col>{data?.field_tr_tbl_d_title || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('traineeName')}:
                        </Col>
                        <Col>{data?.field_tr_tbl_d_trainee || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('startPeriodComplete')}:
                        </Col>
                        <Col>{formatDate(data?.field_tr_tbl_d_sta_per_complete)}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('endPeriodComplete')}:
                        </Col>
                        <Col>{formatDate(data?.field_tr_tbl_d_end_per_complete)}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('startPeriodPhysical')}:
                        </Col>
                        <Col>{formatDate(data?.field_tr_tbl_d_sta_per_physical)}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('endPeriodPhysical')}:
                        </Col>
                        <Col>{formatDate(data?.field_tr_tbl_d_end_per_physical)}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('receivingOrg')}:
                        </Col>
                        <Col>{data?.field_tr_tbl_d_rec_org || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('orgAddress')}:
                        </Col>
                        <Col>{data?.field_tr_tbl_d_rec_org_add || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('orgSector')}:
                        </Col>
                        <Col>{data?.field_tr_tbl_d_rec_org_sec || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('orgWebsite')}:
                        </Col>
                        <Col>{data?.field_tr_tbl_d_rec_org_web || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('programmeDescription')}:
                        </Col>
                        <Col style={{ whiteSpace: 'pre-wrap' }}>{data?.field_tr_tbl_d_program || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('knowledgeSkillsCompetences')}:
                        </Col>
                        <Col style={{ whiteSpace: 'pre-wrap' }}>{data?.field_tr_tbl_d_knowledge || ''}</Col>
                    </Row>
                    <Row style={{ paddingTop: 20, paddingBottom: 10 }}>
                        <Col>
                            <hr style={{ margin: 0, borderTop: '2px solid #dee2e6' }} />
                        </Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                            {t('evaluation')}:
                        </Col>
                        <Col style={{ whiteSpace: 'pre-wrap' }}>{data?.field_tr_tbl_d_evaluation || ''}</Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
};

export default CertificateTable;